import {Injectable} from '@angular/core';
import {ParamMap} from '@angular/router';
import {MenuItemType} from '@models/sidebar/menu-item-type';
import {PageGlobalParameters} from '@models/pages/page-global-parameters';
import {utob} from '@prototypes/global.functions';

@Injectable({
  providedIn: 'root'
})
export class PagesHelperService {

  public getPageDetailsFromUrl(parameters: ParamMap): PageGlobalParameters {
    const result: PageGlobalParameters = new PageGlobalParameters();
    const details = parameters.get('details');
    if (!details) {
      return result;
    }

    const parsedDetails = JSON.parse(utob(details));

    result.pageName = parsedDetails.name;
    result.pageType = parsedDetails.type as MenuItemType;
    result.parentType = parsedDetails.parentType as MenuItemType;
    result.machineId = parsedDetails.machine;
    result.machineryGroupId = parsedDetails.machineGroupId;
    result.organizationId = parsedDetails.organization;
    result.pageId = parsedDetails.pageId;
    result.machineCategory = parsedDetails.machineCategory;
    result.embeddedContendUrl = parsedDetails.url;
    result.firebaseUserId = parsedDetails.firebaseUserId;
    result.widgetInformation = parsedDetails.widgetInformation;
    result.interactiveDataAnalysisMenuItem = parsedDetails.interactiveDataAnalysisMenuItem;
    result.associatedMenuItem = parsedDetails.actualMenuItem;
    return result;
  }

}
